import { Crew } from '@/types';
import api from './client/axios';

export const getAllCrews = async (): Promise<Crew[]> => {
  const response = await api.get('/crews');
  return response.data.crews;
};

export const createCrew = async (crewData: any): Promise<any> => {
  const response = await api.post('/crews', crewData);
  return response.data;
};

export const updateCrew = async (payload: any): Promise<any> => {
  const response = await api.put(`/crews/${payload.crewId}/update`, payload);
  return response.data;
};

export const createCrewMember = async (
  userId: string,
  crewId: string,
  data: any,
): Promise<any> => {
  const response = await api.post(`/crews/${crewId}/member/${userId}`, data);
  return response.data;
};

export const deleteCrewMember = async (
  userId: string,
  crewId: string,
): Promise<any> => {
  const response = await api.delete(`/crews/${crewId}/member/${userId}`);
  return response.data;
};

export const getCrewById = async (crewId: string) => {
  const response = await api.get(`/crews/${crewId}`);
  return response.data.crew;
};

export const getCrewMembers = async (crewId: string) => {
  const response = await api.get(`/crews/${crewId}/members`);
  return response.data;
};
